export default __webpack_public_path__ + "static/media/Practera_Logo_Brandmark_Color_RGB.393636e4.png";